import Carousel from "react-bootstrap/Carousel";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {fetchProgramsByPagination} from "./../services/ProgramService";
import { IMAGE_BASE } from "../Config";

type Program = {
  _id: string;
  title: string;
  description: string;
  image1?: string;
};

function TopCard() {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState<Program[]>([]);

  useEffect(() => {
    // Replace with your actual API endpoint
    const fetchPrograms = async () => {
      try {
        const response = await fetchProgramsByPagination(1, 5, "createdAt");
        setPrograms(response.programs || []);
      } catch (error) {
        console.error("Error fetching programs:", error);
      }
    };
    fetchPrograms();
  }, []);

  return (
    <Carousel>
      {programs.map((program) => (
        <Carousel.Item key={program._id}>
          {program.image1 ? (
            <img
              src={IMAGE_BASE + program.image1}
              alt={program.title}
              className="d-block w-100"
              style={{ maxHeight: 400, objectFit: "cover" }}
            />
          ) : (
            <div style={{ height: 400, background: "#eee" }} />
          )}
          <Carousel.Caption>
            <h3>{program.title}</h3>
            <p>{program.description}</p>
            <button 
              type="button" 
              className="btn btn-secondary"
              onClick={() => navigate(`/play/${program._id}/schedule`)}
            >
              Check Schedules
            </button>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default TopCard;
